var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16 13h-3V3h-2v10H8l4 4 4-4zm4 8v-2H4v2h16z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }